import { render, staticRenderFns } from "./BeerList.vue?vue&type=template&id=07c2f266&"
import script from "./BeerList.vue?vue&type=script&lang=js&"
export * from "./BeerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports